<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <div class="ttshop_barter">
          <div class="ttshop_bartertitle">
            <h4>申请售后</h4>
          </div>
          <div class="ttshop_barternav clearfloat">
            <p class="ttshop_bartershop">商品信息</p>
            <p class="ttshop_barterdj">单价</p>
            <p class="ttshop_barterdj">数量</p>
            <p class="ttshop_barterdj">支付总金额</p>
          </div>
          <div class="ttshop_bartercon">
            <div class="ttshop_barterlist">
              <div class="ttshop_barterlistitle clearfloat">
                <!-- <p>2019-08-20 11:55:41</p> -->
                <!-- <p>订单号：<span>127830913797</span></p> -->
                <p>卖家：<strong>{{list.mch_name}}</strong></p>
              </div>
              <div class="ttshop_barterlistcon clearfloat">
                <div class="ttshop_bartershoping clearfloat">
                  <div class="ttshop_barterimg">
                    <img class="img-default" :src="list.goods_pic" alt="">
                  </div>
                  <div class="ttshop_bartertext">
                    <h5 class="show-two-lines" :title="list.name">{{list.name}}</h5>
                    <span v-for="(attr,ids) in list.attr" :key="ids">{{attr.attr_group_name}}:<strong>{{attr.attr_name}}</strong></span>
                  </div>
                </div>
                <div class="ttshop_barterdjer">
                  <p>¥ {{list.pay_price}}</p>
                </div>
                <div class="ttshop_barterdjer">
                  <p>{{list.num}}</p>
                </div>
                <div class="ttshop_barterdjer">
                  <p>¥ {{list.pay_price}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="ttshop_barterbut">
            <h4>选择服务类型</h4>
            <div class="ttshop_barterbuted">
              <div class="ttshop_barterbutlist">
                <ul class="clearfloat">
                  <!-- <li class="clearfloat" v-if="list.is_exchange==1" :class="{active: 2 == barteractive}" @click="barter(2)">
                    <i><img class="img-default" src="../../assets/images/ttshop_a.png" alt=""></i>
                    <div class="ttshop_barterbutext">
                      <h5>我要换货</h5>
                      <p>需要换货，无需退款</p>
                    </div>
                  </li> -->
                  <li class="clearfloat" v-if="list.is_retreat==1" :class="{active: 1 == barteractive}" @click="barter(1)">
                    <i><img class="img-default" src="../../assets/images/ttshop_b.png" alt=""></i>
                    <div class="ttshop_barterbutext">
                      <h5>我要退货退款</h5>
                      <p>商品不想要了，或商品久未到货</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="ttshop_barterbutshy">
                <h4>售后原因：</h4>
                <textarea v-model="desc" placeholder="填写售后说明"></textarea>
              </div>
              <div class="ttshop_barterbutup">
                <h4>上传凭证：<span>(最多可上传5张图片，每张图片大小不超过5M，支持bmp,gif,jpg,png,jpeg格式文件)</span></h4>
                <div class="ttshop_barterbutupimg">
                  <el-upload action="gdjy/default/upload_image" :data="voucherData" list-type="picture-card" :auto-upload="true" name='file' accept="image/*" :limit="imgLimit" :file-list="productImgs" :multiple="isMultiple" :on-remove="handleRemove" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-exceed="handleExceed" :on-error="imgUploadError">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img class="img-default" width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
                </div>
              </div>
              <div class="ttshop_barterbutlast">
                <button @click="submitBtn">提交</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
export default {
  components: {
    Header,
    Userheader,
    Foot,
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      productImgs: [],
      isMultiple: true,
      imgLimit: 5,
      barteractive:-1,
      id: this.$route.query.id,
      list: "",
      desc: "",
      uploaded_pic_list: [],
      voucherData:{},
    };
  },
  mounted() {
    this.voucherData={
      'access_token':this.$store.state.user.access_token
    };
    this.getData();
  },
  methods: {
    //获取数据
    getData() {
      this.$api
        .refundPreview({
          order_detail_id: this.id,
        })
        .then((res) => {
          console.log(res);
          this.list = res.data;
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },
    // 选择退换货方式
    barter(index) {
      this.barteractive = index;
    },

    handleRemove(file, fileList) {
      //移除图片
      // console.log(file, fileList);
      for (let i in this.uploaded_pic_list) {
        if (file.response.data.url == this.uploaded_pic_list[i]) {
          this.uploaded_pic_list.splice(i, 1);
        }
      }
    },
    // handlePictureCardPreview(file) { //预览图片时调用
    // 	// console.log(file);
    // 	this.dialogImageUrl = file.url;
    // 	this.dialogVisible = true;
    // },

    beforeAvatarUpload(file) {
      //文件上传之前调用做一些拦截限制
      // console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "jpg" ||
        testmsg === "JPG" ||
        testmsg === "png" ||
        testmsg === "PNG" ||
        testmsg === "bpm" ||
        testmsg === "BPM" ||
        testmsg === "jpeg" ||
        testmsg === "JPEG" ||
        testmsg === "gif" ||
        testmsg === "GIF";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension) {
        this.$message({
          message: "上传文件格式不正确，请上传jpg/jpeg/gif/png/bmp格式的图片",
          type: "error",
        });
        return false; //必须加上return false; 才能阻止
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return extension && isLt2M;
    },
    handleAvatarSuccess(res, file) {
      //图片上传成功
      // console.log(res);
      // console.log(file);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.uploaded_pic_list.push(file.response.data.url);
      // console.log(this.uploaded_pic_list)
    },
    handleExceed(files, fileList) {
      //图片上传超过数量限制
      this.$message.error("上传图片不能超过5张!");
      // console.log(file, fileList);
    },
    imgUploadError(err, file, fileList) {
      //图片上传失败调用
      // console.log(err)
      this.$message.error("上传图片失败!");
    },
    //提交
    submitBtn() {
      if (!this.desc) {
        this.$message.error("请输入申请原因!");
        return false;
      }
      let data = {
        type: this.barteractive,
        desc: this.desc,
        order_detail_id: this.id,
      };
      if (this.uploaded_pic_list.length > 0) {
        data.pic_list = JSON.stringify(this.uploaded_pic_list);
      }
      console.log(data);


      this.$api
        .refund(data)
        .then((res) => {
          console.log(res);
          // this.list = res.data;
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.$router.replace("/ttshop_usermyorder");
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
           this.$message({
            message: res.msg,
            type: "error",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.ttshop_barter {
  width: 100%;
  background: #fff;
  padding: 24px 20px;
  box-sizing: border-box;
  .ttshop_bartertitle {
    width: 100%;
    margin-bottom: 24px;
    h4 {
      font-size: 18px;
      color: #333;
      font-weight: 600;
    }
  }
  .ttshop_barternav {
    width: 100%;
    height: 42px;
    background: #f5f5f5;
    margin-bottom: 20px;
    .ttshop_bartershop {
      float: left;
      width: 40%;
      font-size: 12px;
      color: #333;
      // padding-top: 8px;
      height:100%;
      line-height: 42px;
      padding-left: 20px;
      font-size:14px;
      font-weight:600;
      box-sizing: border-box;
    }
    .ttshop_barterdj {
      float: left;
      width: 20%;
      font-size: 12px;
      color: #333;
      // padding-top: 8px;
      
      font-size:14px;
      font-weight:600;
      height:100%;
      line-height: 42px;
      box-sizing: border-box;
      text-align: center;
    }
  }
  .ttshop_bartercon {
    width: 100%;
    margin-bottom: 40px;
    .ttshop_barterlist {
      width: 100%;
      .ttshop_barterlistitle {
        width: 100%;
        height: 36px;
        background: #f5f5f5;
        padding: 0 20px;
        box-sizing: border-box;
        p {
          float: left;
          font-size: 14px;
          color: #999;
          padding-top: 8px;
          box-sizing: border-box;
          margin-right: 24px;
          &:last-child {
            margin-right: 0;
          }
          span {
            font-size: 14px;
            color: #999;
          }
          strong {
            font-size: 14px;
            color: #333;
            font-weight: 500;
          }
        }
      }
      .ttshop_barterlistcon {
        width: 100%;
        min-height: 113px;
        border: 1px solid #ebebeb;
        border-top: 0;
        box-sizing: border-box;
        .ttshop_bartershoping {
          float: left;
          width: 40%;
          min-height: 113px;
          padding: 16px 20px;
          box-sizing: border-box;
          border-right: 1px solid #ebebeb;
          .ttshop_barterimg {
            float: left;
            width: 80px;
            height: 80px;
            margin-right: 12px;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .ttshop_bartertext {
            float: left;
            width: 75%;
            h5 {
              font-size: 14px;
              color: #333;
              line-height: 18px;
              font-weight: 400;
              margin-bottom: 8px;
            }
            span {
              font-size: 14px;
              color: #999;
              margin-right: 5px;
              strong {
                font-size: 12px;
                color: #999;
                font-weight: 400;
              }
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
        .ttshop_barterdjer {
          float: left;
          width: 20%;
          height: 113px;
          padding: 16px 20px;
          box-sizing: border-box;
          border-right: 1px solid #ebebeb;
          &:last-child {
            border-right: 0;
          }
          p {
            font-size: 14px;
            color: #333;
            font-weight: 400;
            line-height: 18px;
            text-align: center;
          }
        }
      }
    }
  }
  .ttshop_barterbut {
    width: 100%;
    h4 {
      font-size: 18px;
      color: #333;
      font-weight: 600;
      line-height: 18px;
      margin-bottom: 9px;
    }
    .ttshop_barterbuted {
      width: 100%;
      border: 1px solid #ebebeb;
      padding: 20px;
      border-radius: 2px;
      margin-bottom: 26px;
      box-sizing: border-box;
      .ttshop_barterbutlist {
        width: 100%;
        margin-bottom: 24px;
        ul {
          li {
            float: left;
            width: 300px;
            height: 80px;
            padding: 20px 17px;
            box-sizing: border-box;
            border: 1px solid #ebebeb;
            border-radius: 2px;
            margin-right: 16px;
            cursor: pointer;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            &::before {
              content: "";
              width: 12px;
              height: 12px;
              background: url(../../assets/images/ttshop_actives.png) center
                no-repeat;
              position: absolute;
              bottom: 0px;
              right: 0px;
              display: none;
            }
            &:last-child {
              margin-right: 0;
            }
            &.active {
              border-color: #ff3346;
            }
            &.active::before {
              display: block;
            }
            i {
              float: left;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 16px;
              img {
                display: block;
                border-radius: 50%;
              }
            }
            .ttshop_barterbutext {
              float: left;
              width: 75%;
              padding-top: 4px;
              box-sizing: border-box;
              h5 {
                font-size: 14px;
                color: #333;
                font-weight: 600;
                line-height: 14px;
                margin-bottom: 8px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              p {
                font-size: 14px;
                color: #666;
                font-weight: 500;
                line-height: 14px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
      .ttshop_barterbutshy {
        width: 100%;
        margin-bottom: 24px;
        h4 {
          font-size: 16px;
          color: #333;
          font-weight: 600;
          line-height: 16px;
          margin-bottom: 8px;
        }
        textarea {
          width: 616px;
          height: 112px;
          border: 1px solid #ebebeb;
          border-radius: 2px;
          font-size: 14px;
          color: #333;
          padding: 15px 16px;
          box-sizing: border-box;
          outline: none;
          resize: none;
        }
      }
      .ttshop_barterbutup {
        width: 100%;
        h4 {
          font-size: 16px;
          color: #333;
          font-weight: 500;
          line-height: 16px;
          margin-bottom: 8px;
          span {
            font-size: 14px;
            color: #999;
            margin-left: 5px;
          }
        }
        .ttshop_barterbutupimg {
          width: 100%;
          overflow: hidden;
          margin-bottom: 32px;
        }
      }
      .ttshop_barterbutlast {
        width: 100%;
        margin-bottom: 34px;
        button {
          display: block;
          width: 116px;
          height: 32px;
          font-size: 14px;
          color: #fff;
          border-radius: 2px;
          outline: none;
          border: 0;
          cursor: pointer;
          background: #ff0e25;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;
          &:hover {
            box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
          }
        }
      }
    }
  }
}
</style>
